export default __webpack_public_path__ + "static/media/text-align-justify-16.1371373b.svg";